<!-- START: Desktop frame -->
<div class="desktop-border">
  <div class="desktop-screen">
    <ng-content></ng-content>
  </div>
</div>
<!-- END: Desktop frame -->
